(function () {
	'use strict';
	angular.module('app.setup')
		.controller('viewMetrics', viewMetrics);

	viewMetrics.$inject = ['$scope', '$state', '$timeout', 'tableRenderService', 'leanFilterService', 'tableService', '$translate'];

	function viewMetrics($scope, $state, $timeout, tableRenderService, leanFilterService, tableService, $translate) {
		var vm = this;
		var reportSettingsName = 'ViewMetrics';
		var pinnedColumns = [];
		var defaultFilters = [];
		var rendererParams = {
			'viewLink': '/application/f/home.html#/setup/configure-metric?ndx='
		};
		// Extra query params to send to backend in data requests
		var extraParams = [{
			excelReportName: 'PurchaseOrderReceipt'
		}];
		// Extra drilldown query params to parse
		var extraFilters = [];

		var columns = [
			{
				'id': 'category',
				'display': 'Category',
				'width': 120
			},
			{
				'id': 'name',
				'display': 'Metric Name',
				'width': 220,
				'enableGrouping': false,
				'renderer': tableRenderService.hyperLink,
				'type': 'metric'
			},
			{
				'id': 'metricDescription',
				'display': 'Metric Description',
				'width': 220,
				'enableGrouping': false
			},
			{
				'id': 'metricLevelType',
				'display': 'Metric Type',
				'width': 120,
				'enableGrouping': false
			},
			{
				'id': 'metricEntryType',
				'display': 'Entry Type',
				'width': 150,
				'enableGrouping': false
			},
			{
				'id': 'resType',
				'display': 'Scope',
				'width': 140,
				'enableGrouping': false
			},
			{
				'id': 'metricOwner',
				'display': 'Metric Owner',
				'width': 160,
				'enableGrouping': false
			},
			{
				'id': 'active',
				'display': 'Active',
				'width': 90,
				'enableGrouping': false
			},
			{
				'id': 'displayRes',
				'display': 'Frequency',
				'width': 90,
				'enableGrouping': false
			}
		];

		$scope.filterService = leanFilterService;
		vm.useSiteSwitcher = true;
		vm.showExcel = false;
		vm.actionButtonText = $translate.instant('Add Metric');
		vm.broadcastAction = broadcastAction;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'View Metrics';
		vm.showActionButton = true;

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				if (response[0] && response[0].length) {
					angular.forEach(response[0], function (row) {
						if (row.active === 1) {
							row.active = 'Yes';
						} else {
							row.active = 'No';
						}
						if (row.metricEntryType === 'ProcurementLog') {
							row.metricEntryType = 'System';
						}
						row.name = strip(row.name);
					});
				}
				return response;
			});
		}

		init();

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/Metrics/View',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'categoryName',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			hideSearch: true,
			setColumnDefaults: true,
			isGlobalReportSetting: false,
			useAdminSiteForReportSettings: true
		};

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useAdminFactory = true;
			var filters = [
				$scope.filterService.filterDefinitions.AllMetricCategories,
				$scope.filterService.filterDefinitions.MetricOwner,
				$scope.filterService.filterDefinitions.MetricTypes,
				$scope.filterService.filterDefinitions.EntryType,
				$scope.filterService.filterDefinitions.ResolutionType,
				$scope.filterService.filterDefinitions.Activated
			];
			$scope.filterService.setMasterFilterList(filters);
		}

		function broadcastAction() {
			$state.go('app.setup.configure-metric');
		}
	}
})();
